import * as requests from '../api-request'

export const upload = async ({ file, intent = 'auto', context = 'newProject' }) => {
  // eslint-disable-next-line no-undef
  const formData = new FormData()
  formData.append('file', file)
  formData.append('intent', intent)
  formData.append('context', context)
  return requests.toJSON('POST', 'project-wizard/uploads', formData)
}

export const getUpload = async (uploadUuid) => {
  return requests.toJSON('GET', `project-wizard/uploads/${uploadUuid}`)
}

export const linkUploadToScript = async ({ projectUuid, scriptUuid, uploadUuid }) => {
  return requests.toJSON('POST', `project-wizard/uploads/${uploadUuid}/link`, {
    projectUuid,
    scriptUuid
  })
}

export const saveOutlineMemory = async ({ generationUuid, outline, projectUuid, scriptUuid }) => {
  return requests.toJSON('POST', `project-wizard/projects/${projectUuid}/outline-memory`, {
    generationUuid,
    outline,
    scriptUuid
  })
}

export const generateOutline = async (data = {}) => {
  return requests.toJSON('POST', 'nolan/project_outline', data)
}
